import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import schema from './ChangeLanguage.schema';
import FormLayout from './ChangeLanguage.layout';
import FormCreator from '../FormCreator';
import { useDispatch, useSelector } from 'react-redux';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { createStructuredSelector } from 'reselect';
import { makeSelectLocale } from '../LanguageProvider/selectors';
import { FormattedMessage } from 'react-intl';
import messages from '../UserProfileMenu/messages';
import { changeLanguuageAction } from '../../appContainer/actions';
import { changeLocale } from '../LanguageProvider/actions';

const stateSelector = createStructuredSelector({
  locale: makeSelectLocale,
});

function ChangeLanguage(props) {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const { locale } = useSelector(stateSelector);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLanguageChange = formState => {
    const { locale } = formState;
    props.beforeChangeHandler()
    if (props.dontSetToUser) {
      dispatch(changeLocale(locale))
    } else {
      dispatch(changeLanguuageAction.Request(locale));
    }
    handleClose();
  };

  const changeLanguage = <FormattedMessage {...messages.changeLanguage} />;

  return (
    <div className={props.className}>
      <ListItemText onClick={handleClickOpen}>{changeLanguage}</ListItemText>
      <Dialog onClose={handleClose} open={open}>
        <Typography variant="h2">{changeLanguage}</Typography>
        <DialogContent>
          <DialogContentText>
            <FormattedMessage {...messages.changeLanguageText} />
          </DialogContentText>
          <FormCreator
            formElements={FormLayout}
            formValues={{ locale }}
            onSubmit={handleLanguageChange}
            submitButtonTitle={changeLanguage}
            validationSchema={schema}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

ChangeLanguage.defaultProps = {
  beforeChangeHandler: () => null
}

export default ChangeLanguage
